import { render, staticRenderFns } from "./TabsContent4.vue?vue&type=template&id=abc80106&scoped=true"
import script from "./TabsContent4.vue?vue&type=script&lang=js"
export * from "./TabsContent4.vue?vue&type=script&lang=js"
import style0 from "./TabsContent4.vue?vue&type=style&index=0&id=abc80106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc80106",
  null
  
)

export default component.exports